/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetUserWalletOptionRespVo } from './GetUserWalletOptionRespVo';
import {
    GetUserWalletOptionRespVoFromJSON,
    GetUserWalletOptionRespVoFromJSONTyped,
    GetUserWalletOptionRespVoToJSON,
    GetUserWalletOptionRespVoToJSONTyped,
} from './GetUserWalletOptionRespVo';

/**
 * 
 * @export
 * @interface ResponseListGetUserWalletOptionRespVo
 */
export interface ResponseListGetUserWalletOptionRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListGetUserWalletOptionRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListGetUserWalletOptionRespVo
     */
    message?: string;
    /**
     * 
     * @type {Array<GetUserWalletOptionRespVo>}
     * @memberof ResponseListGetUserWalletOptionRespVo
     */
    data?: Array<GetUserWalletOptionRespVo>;
}

/**
 * Check if a given object implements the ResponseListGetUserWalletOptionRespVo interface.
 */
export function instanceOfResponseListGetUserWalletOptionRespVo(value: object): value is ResponseListGetUserWalletOptionRespVo {
    return true;
}

export function ResponseListGetUserWalletOptionRespVoFromJSON(json: any): ResponseListGetUserWalletOptionRespVo {
    return ResponseListGetUserWalletOptionRespVoFromJSONTyped(json, false);
}

export function ResponseListGetUserWalletOptionRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListGetUserWalletOptionRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(GetUserWalletOptionRespVoFromJSON)),
    };
}

export function ResponseListGetUserWalletOptionRespVoToJSON(json: any): ResponseListGetUserWalletOptionRespVo {
    return ResponseListGetUserWalletOptionRespVoToJSONTyped(json, false);
}

export function ResponseListGetUserWalletOptionRespVoToJSONTyped(value?: ResponseListGetUserWalletOptionRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(GetUserWalletOptionRespVoToJSON)),
    };
}

